import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function FailedApproaches() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const approaches = [{
    title: 'Cold Turkey without a Plan',
    description: 'Hiding the iPad in a moment of anger leads to hours of whining until you finally cave just to stop the noise.'
  }, {
    title: 'Educational App Justification',
    description: 'Your child\'s brain doesn\'t care if the app is "learning" vowels; the high-speed sensory input is still creating a chemical dependency.'
  }, {
    title: 'The "5-Minute" Timer',
    description: 'Giving "just five more minutes" makes the screen the ultimate high-value prize, increasing the obsession rather than satisfying it.'
  }];
  return <section ref={ref} className="px-6 py-20" style={{
    backgroundColor: 'var(--color-background)'
  }} data-id="element-19">
      <div className="max-w-3xl mx-auto" data-id="element-20">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-3xl md:text-4xl font-bold mb-4 text-center" style={{
        fontFamily: 'var(--font-heading)',
        color: 'var(--color-text)'
      }} data-id="element-21">
          Why What You Tried Didn't Work
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.1
      }} className="text-center text-lg mb-12 opacity-70" style={{
        color: 'var(--color-text)'
      }} data-id="element-22">
          These common strategies actually make the problem worse.
        </motion.p>

        <div className="space-y-6" data-id="element-23">
          {approaches.map((approach, index) => <motion.div key={approach.title} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          ease: 'easeOut',
          delay: 0.15 + index * 0.1
        }} className="p-6 rounded-lg" style={{
          backgroundColor: 'var(--color-background-alt)',
          border: '1px solid var(--color-border)'
        }} data-id="element-24">
              <div className="flex items-start gap-4" data-id="element-25">
                <XCircleIcon className="w-6 h-6 flex-shrink-0 mt-1" style={{
              color: 'var(--color-negative)'
            }} data-id="element-26" />
                <div data-id="element-27">
                  <h3 className="text-xl font-semibold mb-2" style={{
                fontFamily: 'var(--font-heading)',
                color: 'var(--color-text)'
              }} data-id="element-28">
                    {approach.title}
                  </h3>
                  <p style={{
                color: 'var(--color-text)'
              }} data-id="element-29">
                    {approach.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}